import styled from '@emotion/styled';

import { rem } from '@app/styles/theme/layout';

export const BREAKPOINT_WIDE = rem(770);

export const CartGrid = styled.div`
  display: grid;
  align-items: stretch;
  grid-template-columns:
    0
    1fr
    0
    minmax(80px, 1fr)
    minmax(80px, 1fr);

  @media (min-width: ${BREAKPOINT_WIDE}) {
    grid-template-columns: 150px 2fr 1fr 1fr 1fr;
  }
`;

export const CartGridCell = styled.div<{
  hAlign?: 'left' | 'center' | 'right';
}>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: ${rem(8)};
  border-top: 1px solid #e5e5e5;
  overflow: hidden;
  align-items: ${({ hAlign }) => {
    if (hAlign === 'right') return 'flex-end';
    if (hAlign === 'center') return 'center';
    return 'flex-start';
  }};

  @media (min-width: ${BREAKPOINT_WIDE}) {
    padding: ${rem(15)} ${rem(25)};
  }
`;

export const CheckoutButtonCell = styled(CartGridCell)`
  grid-column: 1 / 6;
  padding-top: 0;
  border: none;
`;

export const ContinueShoppingButtonCell = styled(CartGridCell)`
  display: none;

  @media (min-width: ${BREAKPOINT_WIDE}) {
    display: initial;
    grid-column: 1 / 3;
  }
`;

export const CartTotalsCell = styled(CartGridCell)`
  grid-column: 1 / 6;

  @media (min-width: ${BREAKPOINT_WIDE}) {
    grid-column: 3 / 6;
  }
`;
